<template>
  <v-container>
   <v-row>
      <v-col
        xs="12"
      >
        <v-card >
          <v-card-title>
            <span color="info">
              <strong>{{subattending.transaction.platform_id || 'Sem código'}}</strong> 
              - <strong v-if="subattending.attending.finished_at" class="approved"> APROVADA </strong> <span v-else> {{subattending.transaction.status.name}} </span>
            </span>
          </v-card-title>
          <v-card-text>            
            <v-row cols="12">
              <v-col md="6">
                <p>
                  Forma de pagamento: <strong>{{subattending.transaction.payment.name}}</strong>
                </p>
                <div v-if="subattending.new_transaction">
                  Nova tentativa de compra via {{subattending.new_transaction.payment.name}} {{subattending.new_transaction.status.name}} ({{subattending.new_transaction.platform_id}})                           
                </div>
                <div>
                  <p>Cliente: <strong>{{subattending.transaction.subcustomer.name}}</strong></p>
                  <p>Contatos:</p>
                  <ul>
                    <li v-if="subattending.transaction.subcustomer.checkout_phone">
                      {{`Telefone: ${subattending.transaction.subcustomer.checkout_phone}`}}
                    </li>
                    
                    <li v-if="subattending.transaction.subcustomer.checkout_email">
                      {{`Email: ${subattending.transaction.subcustomer.checkout_email}`}}
                    </li>

                  </ul>
                  <div v-if="subattending.affiliate">
                    <p>Afiliado: </p>
                    {{subattending.affiliate && subattending.affiliate.name}}
                  </div>
                  <div v-else>
                    <p>Pedido sem afiliado</p>
                  </div>
                </div>
              </v-col>
              <v-col md="6">
                <p>
                  {{`Pedido iniciado em: ${formattedOrderDate}`}}
                </p>
                <div v-if="subattending.transaction.due_date">
                  <p>
                    {{`Data de Vencimento do Boleto: ${formattedDueDate}`}}
                  </p>
                </div>
                <p>
                    <u>{{`Momento da aprovação: ${formattedAprovedDate}`}}</u>
                  </p>
                
                <div v-if="subattending.produtos">
                  <p>Produtos do Pedido: </p>
                  <div>
                    <ul>
                      <li v-for="product in subattending.produtos" :key="product">
                        <a v-bind:href="product.link" target='_blank'>{{ product.name }}</a> - Qtd: {{ product.pivot.qtd }}
                      </li>
                    </ul>
                  </div>                
                </div>
                <p>Total: BRL {{subattending.transaction.amount.replace('.', ',')}}</p>
                <p v-if="subattending.plan">Plano: {{subattending.plan.name}}</p>

                <div v-if="subattending.transaction.track_code">
                  <v-btn 
                    color="default" 
                    x-medium            
                    @click="copyBarCode"
                    >
                    Copiar mensagem com link de rastreio
                  </v-btn>
                  <input type="hidden" ref="trackCode" id="bar-code" :value="'Olá ' + subattending.transaction.subcustomer.name  + ', tudo bem? Para acompanhar a entrega do seu pedido na ' + store.name +', por favor clique nesse link: \n ' + subattending.transaction.link_track">
                </div>
              </v-col>
            </v-row>
            <v-btn 
              color="success" 
              x-medium dark
              @click="contactedAt"
              >
              Contatar
              <v-icon right>mdi-whatsapp</v-icon>
            </v-btn>

          </v-card-text>

          <!-- <AttendingHistory /> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
import moment from 'moment'
import request from '../../../request';

export default {
  name: "AttendCard",

  components: {

  },

  computed: {
      formattedOrderDate() {
        const date = moment(this.subattending.transaction.start_date || this.subattending.transaction.created_at);
        return `${date.format('DD/MM/YYYY')} às ${date.format('HH:mm')}`
      },
      formattedDueDate() {
        const date = moment(this.subattending.transaction.due_date);
        return `${date.format('DD/MM/YYYY')}`
      },
      formattedAprovedDate() {
        const date = moment(this.subattending.attending.finished_at);
        return `${date.format('DD/MM/YYYY')}`
      },
  },  

  methods: {
    async openWhatsLink() {
        const wppApi = 'https://api.whatsapp.com/send?phone=';
        const phoneNumber = this.subattending
          .transaction
          .subcustomer
          .checkout_phone
          .replace(/\s|\+*/g,'');

        window.open(encodeURI(`${wppApi}55${phoneNumber}`), "_blank");
    },
    contactedAt(event){
      this.openWhatsLink();
    },
    copyBarCode () {
      let testingCodeToCopy = this.$refs.trackCode
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'foi copiada' : 'não pode ser copiada';
        alert('A mensagem ' + msg);
      } catch (err) {
        alert('oops, aconteceu algo de errado.');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },

  props: {
    subattending: {
      type: Object,
      required: true,
    },
    store: {
      type: Object,
      required: true,
    },
    status: {
      type: Number
    }
  },
}
</script>

<style>
  .approved{
    color:green;
  }
</style>